// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__SmDs+","slider":"styles_slider__IRI6l"};